<template>
  <div>
    <zj-layout-container>
      <zj-layout-header>
        <div class="listtitle">年售票走势</div>
        <el-form
          class="zj-search-form"
          ref="form"
          :model="form"
          :label-width="labelWidth"
        >
          <el-form-item label="年份">
            <el-date-picker
              v-model="chooseDate"
              type="year"
              style="width: 60rem"
              :clearable="false"
            ></el-date-picker>
          </el-form-item>
          <el-form-item label class="right">
            <el-button @click="onSearch">查 询</el-button>
            <el-button @click="onCancel">清 理</el-button>
          </el-form-item>
        </el-form>
        <el-divider></el-divider>
      </zj-layout-header>
      <zj-layout-main>
        <div class="echart">
          <div>
            年销售走势同比
            <LineEchart2Ticket :legendData="legendData" :chartData="yearTicketCompare"></LineEchart2Ticket>
          </div>
          <div>
            近5年销售走势
            <LineEchartTicket :chartData="fiveYearTicket"></LineEchartTicket>
          </div>
        </div>
      </zj-layout-main>
    </zj-layout-container>
  </div>
</template>

<script>
import { getYOYTrendByTimes } from '@/api/src/bigData'
import moment from 'moment'
export default {
  name: "TicketYearTrend",
  controller: "UI",
  action: "TicketYearTrend",
  data() {
    return {
      chooseDate: new Date(),
      yearTicketCompare: {},
      legendData: [new Date().getFullYear(), new Date().getFullYear()-1],
      fiveYearTicket: {}
    };
  },
  mounted: function () {
    this.onSearch();
  },
  methods: {
    getCharts() {
      this.legendData = [this.chooseDate.getFullYear(), this.chooseDate.getFullYear()-1];
      let params = {
        district: this.CNF("app.districtCode"),
        districtCode: this.CNF("app.districtCode"),
        polityType: 3,
        timeType: "month", 
        timeValue: 12,
        startTime: this.chooseDate.getFullYear() + '-01-01',
        endTime: this.chooseDate.getFullYear() + '-12-31'
      }
      //年销售额走势同比
      getYOYTrendByTimes(params).then(res => {
        if(res.data){
          let dataList = res.data.dataList || {};
          let Now = dataList[this.legendData[0]];
          let Last = dataList[this.legendData[1]];
          this.yearTicketCompare = {
            days: Now.map(item => { return moment(item.dataTime).format("MM"); }),
            data: Now.map(item => { return item.count }),
            dataLast: Last.map(item => { return item.count })
          }
        }
      });
      // 近5年销售走势
      let fiveParams = {
        district:this.CNF("app.districtCode"),
        districtCode: this.CNF("app.districtCode"),
        polityType: 3,
        timeType: "year", 
        timeValue: 1,
        startTime: this.chooseDate.getFullYear()-4 + '-01-01',
        endTime: this.chooseDate.getFullYear() + '-12-31'
      }
      getYOYTrendByTimes(fiveParams).then(res => {
        if(res.data){
          let dataList = res.data.dataList || {};
          let temp = this.chooseDate.getFullYear()-4;
          this.fiveYearTicket = {
            days: dataList[temp].map(item => { return item.dataTime; }),
            data: dataList[temp].map(item => { return item.count }),
          }
        }
      });
    },
    onSearch(){
      this.getCharts();
    },
    onCancel(){
      this.chooseDate = new Date();
      this.getCharts();
    }
  },
};
</script>

<style scoped lang="scss">
.echart {
  position: relative;
  width: 100%;
  height: 100%;
}
.echart > div{
  width: 60%;
  height: 48%;
  margin: 0 auto 15px;
  color: #2bc5ff;
  font-weight: bold;
  text-align: center;
}
::v-deep .el-input__inner{
  width: 322px;
}
</style>